import angular from "angular";
import animate from "angular-animate";
//import 'bootstrap/dist/css/bootstrap.css';
import "./app.css";
import moment from "moment";
import uirouter from "angular-ui-router/release/angular-ui-router";
import "moment/locale/sk.js";
import "angular-ui-date/dist/date";
import "angular-ui-bootstrap";
import "jquery-ui/themes/base/all.css";
import "jquery-ui";
import $ from "jquery";
import "metismenu/dist/metisMenu.css";
import "imports-loader?jQuery=jquery!metismenu/dist/metisMenu.js";
import "angular-i18n/sk";
import DataTable from "./DataTable";
import DataBinding from "./Editor/DataBinding";
import Kontakt from "./Kontakt";
import OdberneMiesto from "./OdberneMiesto";
import Osoba from "./Osoba";
import Ucet from "./Ucet";
import Meradlo from "./Meradlo";
import Odpocet from "./Odpocet";
import Samoodpocet from "./Samoodpocet";
import Auth from "./Auth";
import Home from "./Home";
import Util from "./util";
import Uzivatel from "./Uzivatel";
import Menu from "./Menu";
import Help from "./Help";
import RezervovanaKapacita from "./RezervovanaKapacita";
import decimal from "./decimal";
import OTE from "./OTE";
import "./util/ArrayFindPolyfill";
import Fakturacia from "./Fakturacia";
import Cennik from "./Cennik";
import ForecastRules from "./ForecastRules";
import ForecastData from "./ForecastData";
import Translate from "./Translate"
import Toastr from './util/Toastr';
import Reporting from './Reporting';
import ForecastOpm from './ForecastOpm';
import ngIdle from 'ng-idle';
moment.locale("sk");
const MODULE_NAME = "energis";
const APPVERSION = "0.2.0";

var ServerError = function ServerError(err, method) {
  this.type = err.type;
  this.message = err.message;
  this.hierarchy = err.hierarchy;
  this.method = method;
  if (err.cause) {
    this.cause = new ServerError(err.cause);
  }
  this.trace = err.trace;
  this.data = err;
};

ServerError.prototype.is = function(cls) {
  for (var i in this.hierarchy) {
    if (this.hierarchy[i] == cls) {
      return true;
    }
  }
  return false;
};

angular
  .module(MODULE_NAME, [
    uirouter,
    "ui.date",
    "ui.bootstrap",
    animate,
    DataTable,
    DataBinding,
    decimal,
    Util,
    Kontakt,
    OdberneMiesto,
    Osoba,
    Ucet,
    Meradlo,
    Odpocet,
    Auth,
    Home,
    Uzivatel,
    RezervovanaKapacita,
    Menu,
    Help,
    OTE,
    Samoodpocet,
    Fakturacia,
    Cennik,
    ForecastRules,
    ForecastData,
    Reporting,
    ForecastOpm,
    ngIdle
  ])
  .config(function(IdleProvider, KeepaliveProvider) {
  IdleProvider.idle(300);
  IdleProvider.timeout(1800);
  KeepaliveProvider.interval(1);
})
.filter("bytes", function() {
    return function(bytes, precision) {
      if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return "-";
      if (typeof precision === "undefined") precision = 1;
      var units = ["bytes", "kB", "MB", "GB", "TB", "PB"],
        number = Math.floor(Math.log(bytes) / Math.log(1024));
      return (
        (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +
        " " +
        units[number]
      );
    };
  })
  .filter("trans", function() {
    return function(text, replacements) {
      return Translate.trans(text, replacements);
    };
  })
  .value("config", {
    api: "../api.php"
  })
  .run(function($rootScope, $window, Idle, AuthService) {
    $rootScope.$on('IdleTimeout', function() {
      AuthService.setInactivityLogout(true);
      AuthService.logout();
    });
    $rootScope.$on('IdleStart', function () {
      AuthService.resetTimer(600);
    });
    $rootScope.$on('IdleEnd', function () {
      AuthService.keepalive();
      AuthService.setInactivityLogout(false);
      AuthService.stopTimer();
    });
    $rootScope.moment = moment;
    //  $rootScope.array_remove = array_remove;
    $rootScope.dateOptions = {
      dateFormat: "dd.mm.yy",
      firstDay: 1,
      dayNamesMin: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"]
    };
    $rootScope.Math = Math;
    $rootScope.back = function() {
      $window.history.back();
    };
    $rootScope.sidebar = {
      toggle: function() {
        $(".sidebar").toggleClass("menu-show");
      }
    };
    $rootScope.APPVERSION = APPVERSION;
    $rootScope.Translate = Translate;
    $rootScope.Toastr = Toastr;
    Toastr.scope = $rootScope;
    (function() {
      var beforePrint = function() {
        $rootScope.$broadcast("print");
      };

      var afterPrint = function() {};

      if (window.matchMedia) {
        var mediaQueryList = window.matchMedia("print");
        mediaQueryList.addListener(function(mql) {
          if (mql.matches) {
            beforePrint();
          } else {
            afterPrint();
          }
        });
      }

      window.onbeforeprint = beforePrint;
      window.onafterprint = afterPrint;
    })();
  })
  .directive("ngMetis", [
    "$timeout",
    function($timeout) {
      return {
        restrict: "A",
        link: function(scope, el, atts) {
          $timeout(function() {
            $(el).metisMenu();
          }, 0);
        }
      };
    }
  ])
  .factory("server", function(config, $http) {
    var token = null;

    var getRequest = function(method, params) {
      return {
        method: method,
        params: params,
        token: token
      };
    };

    var getRequestUrl = function(method, params) {
      return config.api + "?" + JSON.stringify(getRequest(method, params));
    };

    var rawRequest = function(method, params) {
      return $http.post(config.api, getRequest(method, params));
    };

    var asForm = function(method, params) {
      var $form = $("<form>")
        .attr("method", "POST")
        .attr("action", config.api)
        .attr("target", "_blank");
      var data = getRequest(method, params);
      $form.append(
        $("<input>")
          .attr("type", "hidden")
          .attr("name", "data")
          .val(JSON.stringify(data))
      );
      $("body").append($form);
      $form.submit();
      $form.remove();
    };

    var fn = function(method, params) {
      console.log("calling", method, params);
      return rawRequest(method, params).then(
        function(response) {
          if (
            response.data.error &&
            response.data.error.type == "CSRFException"
          ) {
            console.log("repeat request with token");
            token = response.data.result.token;
            return fn(method, params);
          }
          if (response.data.out) {
            console.log("output", response.data.out);
          }
          if (response.data.error) {
            console.log("application error", response.data.error);
            throw new ServerError(response.data.error, method);
          }
          if (typeof response.data === "string") {
            console.log("server error", response.data);
            throw "ServerError " + response.data;
          }
          console.log(method + "(): result", response.data.result);
          return response.data.result;
        },
        function(err) {
          throw ["Conection error", err];
        }
      );
    };

    fn.getRequestUrl = getRequestUrl;
    fn.rawRequest = rawRequest;
    fn.asForm = asForm;
    return fn;
  });

export default MODULE_NAME;



// WEBPACK FOOTER //
// ./src/app.js